export default __webpack_public_path__ + "img/jp-corry.png";